<div class="form-group-flex-column">
  <mat-label [ngClass]="required ? 'required-field-after' : ''">{{ label }}</mat-label>
  <mat-form-field [ngClass]="classCss" appearance="outline">
    <input [(ngModel)]="value"
           [disabled]="disabled"
           [max]="maxDate"
           [min]="minDate"
           [ngxMatDatetimePicker]="picker"
           [required]="required"
           data-lpignore="true"
           matInput>
    <mat-datepicker-toggle matSuffix
                           [for]="picker"></mat-datepicker-toggle>
    <ngx-mat-datetime-picker #picker
                             [hideTime]="hideTime"
                             [stepHour]="stepHour"
                             [stepMinute]="stepMinute"
                             [stepSecond]="stepSecond"
                             (disableMinute)="false"
                             (enableMeridian)="false"
                             (showSeconds)="false"
                             (showSpinners)="true"
                             (touchUi)="false">
    </ngx-mat-datetime-picker>
    <mat-error *ngIf="error.length > 0">
      {{ error }}
    </mat-error>
  </mat-form-field>
</div>
